export enum StyleType {
    Area = "Area",
    Line = "Line",
    Point = "Point",
    Icon = "Icon",
    Model = "Model",
    LineModel = "LineModel",
    AreaModel = "AreaModel"
}